/**
 * Write a script that will be launched on page load that will walk through all "a" elements and add id attribute
 * if it does not exist with the next rule:
 *
 * use the text of the button as an id (for constancy lets uppercase and replace spaces with "_" )
 *
 * if current id was already assigned to some element add "-N" postfix where "N" is incremented every time the
 * same name was used.
 *
 * @param {jQuery} $ - dependency injection of jQuery object
 */
var md5 = require('md5');
module.exports = function enhanceLinkAttribution($) {
    /**
     * Storage for already registered and used ids
     *
     * @type {Array}
     */
    var registeredIdsCounter = 0;

    /**
     * Transforms button/link text to required id param
     *
     * @param {String} text, that should be id after prepare
     * @returns {String} prepared text
     */
    function prepareText(text) {
        registeredIdsCounter += 1;
        return md5(text) + '-' + registeredIdsCounter;
    }

    /**
     * Iterator that forces id attribute for link
     *
     * @param {HTMLElement} link
     * @returns {undefined}
     */
    function enforceLinkWithId(link) {
        link = $(link); // We want jquery powered element
        if (!link.attr('id')) {
            link.attr('id', prepareText(link.text()));
        }
    }

    Array.prototype.forEach.call($('a'), enforceLinkWithId);
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/utils/link-attribution/link-attribution.js
// module id = 331
// module chunks = 36